// NS-10715 New collection of stores for report ( reports requests ) PW
import csmStore from "./csmStore"

export default {
    modules: {
        csmStore
    },
}
